import React from "react";
import { Form } from "react-bootstrap";
import "./Input.css";

export default function Input({
  label,
  type = "text",
  name,
  value,
  onChange,
  placeholder,
  isInvalid,
  feedback,
  inlineFeedback=false,
  as,
  rows,
  helperText,
  isMandetory,
  options = [],
  multiple = false, // support multiple select
  maxLength,
  isReadOnly= false,
  ...props 
}) {
  return (
    <Form.Group className="mb-3 p-relative">
      <Form.Label className='label'>
        {label}
        {isMandetory && <span className="redtxt">*</span>}
      </Form.Label>

      {type === "select" ? (
        <Form.Select
          name={name}
          value={value}
          onChange={onChange}
          multiple={multiple}
          className={isInvalid ? 'invalidinput' : ''}
          style={{height: multiple ? 'auto' : undefined }}
          isInvalid={inlineFeedback && !!feedback}
          >
          {!multiple && <option value="" disabled>-Select-</option>}
          {options.map((opt, index) => (
            <option key={index} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Form.Select>
        
      ) : (
        <Form.Control
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={isInvalid ? 'invalidinput' : ''}
          as={as}
          rows={rows}
          isInvalid={inlineFeedback && !!feedback}
          autoComplete="off"
          autoFocus={false}
          {...(maxLength !== undefined ? { maxLength } : {})}
          {...(isReadOnly ? { readOnly: true } : {})}
          
        />
      )}

      {helperText && (
        <div className="d-flex justify-content-end">
          <Form.Text className="text-muted fs-small">{helperText}</Form.Text>
        </div>
      )}
      {inlineFeedback && feedback && (
        <Form.Control.Feedback type="invalid" >{feedback}</Form.Control.Feedback>
      )}
    </Form.Group>
  );
}
